import { useEffect, useState } from 'preact/hooks';
import { api } from '../../api.js';
import { t } from '../../i18n/index.js';
import { formatWhen } from './ClosureAdmin.js';

type Backup = { at: number; folder: string; size: string } | null;

/** Latest Google Drive backup; warns when it is older than eight days (weekly minimum + margin). */
export function BackupStatus() {
  const [backup, setBackup] = useState<Backup | undefined>(undefined);
  useEffect(() => {
    api<{ backup: Backup }>('GET', '/api/admin/backup')
      .then((r) => setBackup(r.backup))
      .catch(() => setBackup(null));
  }, []);
  if (backup === undefined) return null;
  const old = !backup || Date.now() - backup.at > 8 * 86_400_000;
  return (
    <section class="card">
      <h2>{t.admin.backup.title}</h2>
      <p class="muted">{t.admin.backup.info}</p>
      <p>{backup ? t.admin.backup.last(formatWhen(backup.at), backup.size) : t.admin.backup.none}</p>
      {old && backup && <p class="error">{t.admin.backup.old}</p>}
    </section>
  );
}
